import { Field, Form, Formik, useFormikContext } from "formik"
import React, { useCallback, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  TabPane,
  Table,
} from "reactstrap"
import {
  TextField,
  SelectionField,
  REQUIRED,
  POSITIVE,
  AMOUNT,
  NO_OF_DAYS,
} from "../../Components/constants/field"
import { useEffect } from "react"
import Loader from "../../Components/Common/Loader"
import DeleteModal from "../../Components/Common/DeleteModal"
import PropTypes from "prop-types"
import {
  AdditionalServicesDetailsPerDay,
  createAdditionalServices,
  deleteAdditionalServices,
  getQuotationDetail,
  updateAdditionalServices,
} from "../../slices/thunks"
import _ from "lodash"
import { useMemo } from "react"
import * as Yup from "yup"
import { useLocation } from "react-router-dom"
import { showModal } from "../../slices/quotation/reducer"

const AdditionalServicePerDay = (props) => {
  let { showTable = true } = props
  const { GSTActiveList, loading: GstLoading } = useSelector(
    (state) => state.Gst
  )
  const dispatch = useDispatch()
  const location = useLocation()

  const urlParams = new URLSearchParams(location.search)
  const qID = urlParams.get("q")
  const {
    activeTab,
    addtionalServicePerDay: { form, list },
    modal: { modal },
  } = useSelector((state) => state.Quotation)

  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteData, setDeleteData] = useState(null)
  const [reload, setReload] = useState(false)

  useEffect(() => {
    if (qID && !modal) {
      let quotationDetail = {
        ID: Number(qID),
      }

      dispatch(getQuotationDetail(quotationDetail))
    }
  }, [reload, qID, modal])

  const handleSubmit = (values, { resetForm }) => {
    let obj = {
      ...values,
    }
    delete obj.GSTTitle
    obj.QuoteID = +obj.QuoteID
    obj.NoOfDays = +obj.NoOfDays
    obj.Rate = +obj.Rate
    obj.Total = +obj.Total
    obj.Margin = +obj.Margin
    obj.MarginTotal = +obj.MarginTotal
    obj.GSTID = +obj.GSTID
    obj.GSTPer = +obj.GSTPer
    obj.GSTAmount = +obj.GSTAmount
    obj.GrandTotal = +obj.GrandTotal
    obj.IsActive = true

    // createAdditional Service Per day
    if (!obj.ID) {
      delete obj.ID
      obj[`OperationType`] = 14
      obj[`QuoteID`] = Number(qID)
      dispatch(createAdditionalServices(obj)).then((res) => {
        setReload(!reload)
        if (res.payload && res.payload.Status === 200) {
          resetForm()
          if (modal) {
            let obj = {
              modal: false,
              modalType: "",
              modalData: {},
            }
            dispatch(showModal(obj))
          }
        }
      })
    } else {
      obj[`OperationType`] = 15
      obj[`QuoteID`] = Number(qID)
      // obj[`IsActive`] = true
      // IsActive
      dispatch(updateAdditionalServices(obj)).then((res) => {
        setReload(!reload)
        if (res.payload && res.payload.Status === 200) {
          resetForm()
          if (modal) {
            let obj = {
              modal: false,
              modalType: "",
              modalData: {},
            }
            dispatch(showModal(obj))
          }
        }
      })
    }
  }

  const editAdditionalServicePerDay = (data) => {
    let detailObj = {
      ID: +data?.ID || "",
      QuoteID: +data?.QuoteID || "",
    }
    dispatch(AdditionalServicesDetailsPerDay(detailObj))
  }

  const onClickDelete = (data) => {
    setDeleteModal(true)
    setDeleteData(data)
  }

  const onDeleted = () => {
    let detailObj = {
      ID: +deleteData?.ID || "",
      QuoteID: +deleteData?.QuoteID || "",
      OperationType: 16,
      IsActive: false,
    }
    dispatch(deleteAdditionalServices(detailObj)).then((res) => {
      if (res.payload && res.payload.Status === 200) {
        setReload(!reload)
        setDeleteModal(false)
        setDeleteData(null)
      }
    })
  }

  if (GstLoading) return <Loader />

  return (
    <TabPane id="steparrow-gen-info" tabId={activeTab}>
      <Card className="border border-black">
        <Formik
          initialValues={form}
          enableReinitialize={true}
          validationSchema={Yup.object({
            Title: Yup.string().nullable(true).required(REQUIRED),
            Rate: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .positive(POSITIVE)
              .required(REQUIRED),
            NoOfDays: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .positive(POSITIVE)
              .lessThan(100, NO_OF_DAYS)
              .required(REQUIRED),
            Total: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .min(0, AMOUNT),
            Margin: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .min(0, AMOUNT),
            MarginTotal: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .min(0, AMOUNT),
            GSTID: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable(),
            GSTAmount: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .min(0, AMOUNT),
            GrandTotal: Yup.number()
              .transform((value) => (Number.isNaN(value) ? null : value))
              .nullable()
              .min(0, AMOUNT),
          })}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form noValidate autoComplete="off">
              <CardHeader>
                <Row>
                  <Col md="9">
                    <h4>Additional Service Per Day*</h4>
                  </Col>
                  <Col md="3">
                    <div className="d-flex align-items-center justify-content-between">
                      <Label htmlFor="MiscDayGrandTotal" className="w-100">
                        Grand Total
                      </Label>

                      <Field
                        name="MiscDayGrandTotal"
                        type="number"
                        className="form-control"
                        id="MiscDayGrandTotal"
                        placeholder="Grand Total"
                        component={TextField}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div>
                  <Row>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="Title">
                          Title:
                        </Label>
                        <Field
                          name="Title"
                          type="text"
                          className="form-control"
                          id="Title"
                          placeholder="Enter Title"
                          component={TextField}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="Rate">
                          Per Day Rate
                        </Label>
                        <Field
                          name="Rate"
                          type="number"
                          className="form-control"
                          id="Rate"
                          placeholder="Enter Per Day Rate"
                          component={TextField}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="NoOfDays">
                          Total Days
                        </Label>
                        <Field
                          name="NoOfDays"
                          type="number"
                          className="form-control"
                          id="NoOfDays"
                          placeholder="Enter Total Days"
                          component={TextField}
                        />
                      </div>
                    </Col>
                    <Total />

                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="Total">
                          Total
                        </Label>
                        <Field
                          name="Total"
                          type="number"
                          className="form-control"
                          id="Total"
                          placeholder="Total"
                          disabled
                          component={TextField}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="Margin">
                          Margin
                        </Label>
                        <Field
                          name="Margin"
                          type="number"
                          className="form-control"
                          id="Margin"
                          placeholder="Margin"
                          component={TextField}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="MarginTotal">
                          Margin Total
                        </Label>
                        <Field
                          name="MarginTotal"
                          type="number"
                          className="form-control"
                          id="MarginTotal"
                          placeholder="Margin Total"
                          component={TextField}
                          disabled
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="GSTID">
                          GST
                        </Label>
                        <Field
                          id="GSTID"
                          name="GSTID"
                          options={
                            Array.isArray(GSTActiveList)
                              ? GSTActiveList.map((gst) => {
                                  return {
                                    value: gst?.ID || "",
                                    label: gst?.Title || "",
                                  }
                                })
                              : []
                          }
                          component={SelectionField}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="GSTAmount">
                          GST Amount
                        </Label>
                        <Field
                          name="GSTAmount"
                          type="number"
                          className="form-control"
                          id="GSTAmount"
                          placeholder="GST Amount"
                          component={TextField}
                          disabled
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="GrandTotal">
                          Total Amount
                        </Label>
                        <Field
                          name="GrandTotal"
                          type="number"
                          className="form-control"
                          id="GrandTotal"
                          placeholder="GrandTotal"
                          component={TextField}
                          disabled
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col lg={12}>
                      <hr></hr>
                    </Col>
                    <Col md="12" className="text-end">
                      <Button className="success" type="submit">
                        Save & Add Another
                      </Button>
                    </Col>
                    <DeleteModal
                      show={deleteModal}
                      onCloseClick={() => setDeleteModal(false)}
                      onDeleteClick={() => onDeleted()}
                    />
                  </Row>
                </div>
              </CardBody>
            </Form>
          )}
        </Formik>
        {showTable ? (
          <CardBody>
            <hr></hr>
            <Col lg={12}>
              <div className="table-responsive mt-2">
                <Table
                  className="align-middle table-nowrap mb-0"
                  striped
                  responsive
                  hover
                >
                  <thead>
                    <tr>
                      <th scope="col">Service</th>
                      <th scope="col">Rate/Day</th>
                      <th scope="col">Total Days</th>
                      <th scope="col">Total Amount</th>
                      <th scope="col">Margin</th>
                      <th scope="col">GST%</th>
                      <th scope="col">GST Amount</th>
                      <th scope="col">Grand Total</th>

                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(list) && list.length ? (
                      list.map((aspd, i) => {
                        return (
                          <tr key={i}>
                            <td scope="col">{aspd?.Title}</td>
                            <td scope="col">{aspd?.Rate}</td>
                            <td scope="col">{aspd?.NoOfDays}</td>
                            <td scope="col">{aspd?.Total}</td>
                            <td scope="col">{aspd?.Margin}</td>
                            <td scope="col">{aspd?.GSTPer}</td>
                            <td scope="col">{aspd?.GSTAmount}</td>
                            <td scope="col">{aspd?.GrandTotal}</td>
                            <td scope="col">
                              {" "}
                              <div
                                className="hstack gap-3 flex-wrap "
                                role="button"
                              >
                                <i
                                  className="ri-edit-line text-success fs-18"
                                  //
                                  onClick={() =>
                                    editAdditionalServicePerDay(aspd)
                                  }
                                ></i>
                                <div className="gap-3 " role="button">
                                  <i
                                    className="ri-delete-bin-fill text-danger fs-18"
                                    onClick={() => onClickDelete(aspd)}
                                  ></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    ) : list.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-center">
                          No Additional Service Per Day found
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>
              </div>
            </Col>
          </CardBody>
        ) : null}
      </Card>
    </TabPane>
  )
}
AdditionalServicePerDay.propTypes = {
  showTable: PropTypes.bool,
}

export default AdditionalServicePerDay

export function TotalSumComponent() {
  const { values, setFieldValue } = useFormikContext()
  const { GSTActiveList } = useSelector((state) => state.Gst)

  const TotalValue = useCallback(
    (values, subArray, type = "sum") => {
      let value = _.filter(
        _.map(_.values(_.pick(values, subArray)), (n) => Number(n)),
        function (num) {
          return _.isNumber(num)
        }
      )

      switch (type) {
        case "multiply":
          value = _.sum(value)
            ? value.reduce((acc, curr) => Number(acc) * Number(curr), 1)
            : 0
          break
        default:
          value = _.sum(value)
          break
      }

      return _.round(value)
    },
    [values]
  )

  // Total
  useMemo(() => {
    setFieldValue("Total", TotalValue(values, ["NoOfDays", "Rate"], "multiply"))
  }, [values?.NoOfDays, values?.Rate])

  // Total Margin Total
  useMemo(() => {
    setFieldValue("MarginTotal", TotalValue(values, ["Total", "Margin"]))
  }, [values?.Total, values?.Margin])

  // GST Total Amount
  useMemo(() => {
    const findGst = _.find(GSTActiveList, (q) => q.ID === Number(values?.GSTID))
    if (findGst?.IsApplyOnServiceMargin) {
      let totalGst = _.round(values?.Margin * ((findGst?.GSTPer || 0) / 100), 2)
      setFieldValue("GSTAmount", totalGst)
    } else {
      let totalGst = _.round(
        values?.MarginTotal * ((findGst?.GSTPer || 0) / 100),
        2
      )
      setFieldValue("GSTAmount", totalGst)
    }
    setFieldValue("GSTPer", findGst?.GSTPer)
  }, [GSTActiveList, values?.GSTID, values?.MarginTotal, values?.Margin])

  //  Grand Total
  //
  useMemo(() => {
    setFieldValue(
      "GrandTotal",
      TotalValue(values, ["MarginTotal", "GSTAmount"])
    )
  }, [values?.MarginTotal, values?.GSTAmount])
  return null
}
export const Total = React.memo(TotalSumComponent)
